__turbopack_context__.v({
  "checkempty": "formRadioInputs-module-scss-module__P_1Eba__checkempty",
  "checkmark": "formRadioInputs-module-scss-module__P_1Eba__checkmark",
  "icon": "formRadioInputs-module-scss-module__P_1Eba__icon",
  "radioInputList": "formRadioInputs-module-scss-module__P_1Eba__radioInputList",
  "radioInputListItem": "formRadioInputs-module-scss-module__P_1Eba__radioInputListItem",
});
